import React, { useState } from "react";
import "./ownAgentName.scss";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import uploadIcon from "../../../../assets/icons/upload.svg";
import { Link } from "react-router-dom";
import ScratchScript from "../../Agents/scratchScript";
import axios from "axios";

const OwnAgentName = ({ title, btnShow, onButtonClick, setUpdateScript, agent,updateAgents, showUpdate }) => {
  var authToken = JSON.parse(localStorage.getItem("bearerToken"));

  const handleClick1 = () => {
    // Assume true is sent when the button is clicked
    onButtonClick(true,title);
  };

  const handleShowUpdateScript = () => {
    setUpdateScript(true);
  };

  // const handleClick2 = () => {
  //   // Assume true is sent when the button is clicked
  //   onButtonClick1(true);
  // };

  const [showComponent, setShowComponent] = useState(false);

  const handleAnchorClick = () => {
    setShowComponent(true);
  };
  const [activeFilter, setActiveFilter] = useState("First");
  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
  };
  const [showScript, setShowScript] = useState(true);
  const handleShowScript = () => {
    setShowScript(false);
    console.log("Script Dikha");
  };

  const [showReno, setShowReno] = useState(true);
  const handleShowReno = () => {
    setShowReno(false);
  };

  const [show, setShow] = useState(false);
  const [showmodal2, setShowmodal2] = useState(false);
  const [showmodal3, setShowmodal3] = useState(false);
  const [showmodal4, setShowmodal4] = useState(false);
  const [showmodal5, setShowmodal5] = useState(false);
  const [showmodal6, setShowmodal6] = useState(false);
  const [showmodal7, setShowmodal7] = useState(false);

  const handleClose = () => setShow(false);
  const handleClose2 = () => setShowmodal2(false);
  const handleClose3 = () => setShowmodal3(false);
  const handleClose4 = () => setShowmodal4(false);
  const handleClose5 = () => setShowmodal5(false);
  const handleClose6 = () => setShowmodal6(false);
  const handleClose7 = () => setShowmodal7(false);

  const handleShow = () => setShow(true);
  const handleShowmodal2 = () => setShowmodal2(true);
  const handleShowmodal3 = () => setShowmodal3(true);
  const handleShowmodal4 = () => setShowmodal4(true);
  const handleShowmodal5 = () => setShowmodal5(true);
  const handleShowmodal6 = () => setShowmodal6(true);
  const handleShowmodal7 = () => setShowmodal7(true);
  const [isClicked, setIsClicked] = useState(false);
  const handleClick = () => {
    setIsClicked(!isClicked);
  };

  // drag state
  const [dragActive, setDragActive] = React.useState(false);
  const inputRef = React.useRef(null);

  // handle drag events
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  // triggers when file is dropped
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      // at least one file has been dropped so do something
      // handleFiles(e.dataTransfer.files);
    }
  };
  const handleChange = function (e) {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      // at least one file has been selected so do something
      // handleFiles(e.target.files);
    }
  };

  const handleDeleteAgent = async () => {
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/customer/agent/${agent?._id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        updateAgents()
        setShowmodal7(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  console.log("agentId For Delete:", agent?._id);

  return (
    <>
      {/* {showScript ? ( */}
      <div className="agentName">
        <h5 className="agent-txt-h5">{title}</h5>
        <div className="agentNameAbsolute">
          <h6>{title}</h6>
          <div className="agentNameAbsoluteMainDiv">
            <div className="callBot">
              <img
                onClick={handleClick1}
                // onClick={handleShow2}
                src="/images/Dashboard/callImg.png"
                alt="..."
              />
              <p>Call with AI Bot</p>
              <div style={{display:"flex" , flexdirection:'row', gap :'24px'}}>
              {/* {btnShow ? ( */}
            {showUpdate && (  <button
                className="agent-btn"
                // onClick={handleShow}
                // onClick={handleShowScript}
                onClick={handleShowUpdateScript}
              >
                Update
              </button>
            )}

              {btnShow ? (
                <button className="agent-btn" onClick={handleShowmodal7}>
                  Delete
                </button>
              ) : (
                <></>
              )}
</div>


              {/* ) : (
                  <></>
                )} */}
              {/* <Modal show={show} onHide={handleClose} className="agentModal">
                  <Modal.Header closeButton>
                    <Modal.Title className="titleOfModal">Create New Agents</Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="modalBody">
                    <h3>Name</h3>
                    <input type="search" placeholder="Enter your Agent Name" />
                    <h3>Choose your use case</h3>

                    <div className="choosingCase">
                      <p>Concrete Restoration</p>
                    </div>
                    <div className="choosingCase">
                      <p>Stucco Repair</p>
                    </div>
                    <div className="choosingCase">
                      <p>Painting</p>
                    </div>
                    <div className="choosingCase">
                      <p>Roofing</p>
                    </div>
                    <div className="choosingCase">
                      <p>Waterproofing</p>
                    </div>
                    <div className="choosingCase">
                      <p>Pool Renovation & Restoration </p>
                    </div>
                    <div className="choosingCase">
                      <p>Pavers and Landscaping </p>
                    </div>
                    <div className="choosingCase">
                      <p>Dock & Deck</p>
                    </div>
                    <div className="choosingCase">
                      <p>Seawalls</p>
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      onClick={() => {
                        handleClose2 && handleClose();
                        handleShowmodal2 && handleShowmodal2();
                      }}
                      className="save-btn"
                    >
                      Save
                    </Button>
                  </Modal.Footer>
                </Modal> */}

              {/* create new agent code */}

              {/* Creating Script Code (Magical or scratch) */}
              {/* <Modal
                  show={showmodal2}
                  onHide={() => {
                    handleClose2 && handleClose2();
                    handleShow && handleShow();
                  }}
                  className="agentModal2"
                >
                  <Modal.Header closeButton></Modal.Header>
                  <Modal.Body className="modalBody">
                    <h4>How do you want to create a script for your agent to follow?</h4>
                    <div className="creating-script-box">
                      <div
                        onClick={() => {
                          handleClose3 && handleClose2();
                          handleShowmodal3 && handleShowmodal3();
                        }}
                        className="magicalBox"
                      >
                        <p>Magically Generate Using AI</p>

                        <span>Have AI magically create a script by uploading a call recording, pasting in your script, or let Landav AI ask you a few you qestions to get context.</span>
                      </div>
                      <Link className="link" to="/scratchScript">
                        <div
                          className="creatingScratchBox"
                          onClick={() => {
                            handleShowScript();
                          }}
                        >
                          <p>Create from Scratch </p>

                          <span>Start with a fresh blank state and create a script from scratch.</span>
                        </div>
                      </Link>
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      onClick={() => {
                        handleClose3 && handleClose2();
                        handleShowmodal3 && handleShowmodal3();
                      }}
                      className="script-btn"
                    >
                      Choose script creation type
                    </Button>
                  </Modal.Footer>
                </Modal> */}
              {/* Creating Script Code */}

              {/* Magically Generating Script Code */}
              {/* <Modal
                  show={showmodal3}
                  onHide={() => {
                    handleClose3 && handleClose3();
                    handleShowmodal2 && handleShowmodal2();
                  }}
                  className="agentModal3"
                >
                  <Modal.Header closeButton></Modal.Header>
                  <Modal.Body className="modalBody">
                    <h4>How do you want to magically generate a script?</h4>
                    <div className="magicalGeneratingMainBox">
                      <div
                        onClick={() => {
                          handleClose3 && handleClose3();
                          handleShowmodal4 && handleShowmodal4();
                        }}
                        className="callRecordingDiv"
                      >
                        <h5>Upload a call recording </h5>
                        <p>Clone your best rep by uploading a call recording.</p>
                      </div>

                      <div
                        onClick={() => {
                          handleClose3 && handleClose3();
                          handleShowmodal5 && handleShowmodal5();
                        }}
                        className="callRecordingDiv"
                      >
                        <h5>Give Group Landev AI you existing script</h5>
                        <p>Copy & paste your current script and let AI reformat it an a way that is easy for your agent to follow.</p>
                      </div>

                      <div
                        onClick={() => {
                          handleClose3 && handleClose3();
                          handleShowmodal6 && handleShowmodal6();
                        }}
                        className="callRecordingDiv"
                      >
                        <h5>Use a proven template from AI</h5>
                        <p>Select a proven template, give AI some basic context, and have AI customize it for your business</p>
                      </div>
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      onClick={() => {
                        handleClose3 && handleClose3();
                        handleShowmodal4 && handleShowmodal4();
                      }}
                      className="script-btn"
                    >
                      Select Magic Generation Type
                    </Button>
                  </Modal.Footer>
                </Modal> */}
              {/* Magically Generating Script Code */}

              {/*Upload Your Call Code */}
              {/* <Modal
                  show={showmodal4}
                  onHide={() => {
                    handleClose4 && handleClose4();
                    handleShowmodal3 && handleShowmodal3();
                  }}
                  className="agentModal4"
                >
                  <Modal.Header closeButton></Modal.Header>
                  <Modal.Body className="modalBody">
                    <h4>Upload a Call Recording</h4>
                    <p className="callRpara">Clone your best rep by uploading a call recording from them and we'll magically create a script for your  Agent to follow based on it.</p>
                    <section id="form-file-upload">
                      <input ref={inputRef} type="file" id="input-file-upload" multiple={true} onChange={handleChange} />
                      <label id="label-file-upload" htmlFor="input-file-upload">
                        <div>
                          <img className="mb-3" src={uploadIcon} alt="" />
                          <p className="upload-text">Click to upload files from computer</p>
                          <p className="upload-text2">or drag and drop here</p>
                        </div>
                      </label>
                      {dragActive && <div id="drag-file-element" onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></div>}
                    </section>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      onClick={() => {
                        handleClose4 && handleClose4();
                        handleShowmodal5 && handleShowmodal5();
                      }}
                      className="script-btn"
                    >
                      Save
                    </Button>
                  </Modal.Footer>
                </Modal> */}
              {/*Upload Your Call Code */}

              {/*Upload Your Script Code */}
              {/* <Modal
                  show={showmodal5}
                  onHide={() => {
                    handleClose5 && handleClose5();
                    handleShowmodal3 && handleShowmodal3();
                  }}
                  className="agentModal5"
                >
                  <Modal.Header closeButton></Modal.Header>
                  <Modal.Body className="modalBody">
                    <h4>Upload Your Script</h4>
                    <p className="callRpara">Upload your script and we'll automatically clean it up to make it much easier for your Air Agent to understand and follow.</p>
                    <textarea className="script-text" type="text" placeholder="Copy and paste your original script here that you want to clean up..."></textarea>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button className="script-btn">New Step</Button>
                  </Modal.Footer>
                </Modal> */}
              {/*Upload Your Script Code */}

              {/* Proven Template Code */}
              {/* <Modal
                  show={showmodal6}
                  onHide={() => {
                    handleClose6 && handleClose6();
                    handleShowmodal3 && handleShowmodal3();
                  }}
                  className="agentModal6"
                >
                  <Modal.Header closeButton></Modal.Header>
                  <Modal.Body className="modalBody">
                    <div className="templateMainWrapper">
                      <div className="templateLeftContent">
                        <h5>Templates</h5>
                        <p onClick={() => handleFilterClick("First")}>Abandon cart</p>
                        <p onClick={() => handleFilterClick("Second")}>Pain/Desire Gap</p>
                        <p>One Word Script</p>
                        <p>Customer Service Script</p>
                        <p>Abandon cart</p>
                        <p>Abandon cart</p>
                        <p>Abandon cart</p>
                      </div>
                      <div className="templateRightContent">
                        {activeFilter === "First" ? (
                          <div className="abandonCartContent">
                            <h5 className="text-center">Preview of selected script</h5>
                            <p>
                              “Hey,
                              <br />
                              !” “My name is Alexander and I’m customer support specialist at [company]” <br />
                              “I hope this is not a bad time, I’m just calling to thank you for visiting our store and ask for some feedback since we’re trying to grow the business and would love to
                              get feedback from a fresh pair of eyes.” <br />
                              “How did you hear about us?” <br />
                              “Was the site easy to use, and did you find what you were looking for?”
                              <br />
                              “I saw you were interested in [insert product they had in their cart here], what interested you about this, and what caused you to leave us before confirming your
                              purchase?” <br />
                              “Do you have any unanswered questions or concerns about the product?” <br />
                              “Thank you for your feedback and your time. If you are still interested, I can send you a 10% discount code.” <br />
                              “Ok, I can just send that over right now. And if you do end up using that discount code, thanks in advance! All support is greatly appreciated.”
                            </p>
                          </div>
                        ) : activeFilter === "Second" ? (
                          <div className="painDesireContent">
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda, rem, dolores eos nobis autem fuga reiciendis ea asperiores iste ad ex alias enim aut cupiditate id sint
                            doloribus maxime. Corrupti!
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </Modal.Body>
                </Modal> */}
            </div>
            <div className="chatBot">
              {
            /*    <Link to="/chatbot">
                <img src="/images/Dashboard/Group 42.png" alt="..." />
              </Link>
              
              <p>Chat with AI Bot</p>
              */
            }

              
              <Modal
                show={showmodal7}
                onHide={() => {
                  handleClose7 && handleClose7();
                }}
                className="agentModal4"
              >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body className="modalBody">
                  <div className="DeleteKnowledgeBase-inner-container">
                    <h5>Are you absolutely sure?</h5>
                    <p>This action can’t be undone. This will permanently delete this</p>
                    <button className="deleteBbtn my-5" onClick={handleDeleteAgent}>
                      Delete
                    </button>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
      </div>
      {/* ) : (
        <ScratchScript userId={'ssss'} agentData={{}} agentPromptType={'meeru'} />
      )} */}
    </>
  );
};

export default OwnAgentName;
